import { render } from "./ApprovedLiquidation.vue?vue&type=template&id=1ab7322a"
import script from "./ApprovedLiquidation.vue?vue&type=script&lang=js"
export * from "./ApprovedLiquidation.vue?vue&type=script&lang=js"

import "./ApprovedLiquidation.vue?vue&type=style&index=0&id=1ab7322a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__